export const QUESTIONS_TYPE = {
  DEFAULT: 'question',
  RATE: 'rate',
  PF: 'PF',
  PAIN: 'pain',
  LIBIDO: 'libido',
  BLADDER: 'bladder',
  ORGASM: 'orgasm',
  GRAPH: 'graph',
  WOMEN: 'women',
  BODY: 'body',
  HEIGHT: 'height',
  WEIGHT: 'weight',
  NAME: 'name'
};